export interface Feature {
  id: string
  name: string
  type: string
  defaultValue?: number | boolean
  required: boolean
}

export interface FeatureItem {
  id: string
  data: {
    type: string
    value: string | number | boolean
  }
}

export interface TemplateFeature {
  id: string
  name: string
  type: string
  value: string | number | boolean
}

export interface FeatureOption {
  label: string
  value: string
}

export interface PricePlanTemplate {
  id: string
  name: string
  externalName: string
  features: TemplateFeature[]
}

export enum SupportType {
  ALL = 'ALL',
  NONE = 'NONE',
  SPECIFIC = 'SPECIFIC',
}

export type CardPartner = string & { readonly CardPartner: unique symbol }
export type Currency = string & { readonly Currency: unique symbol }
export type Country = string & { readonly Country: unique symbol }

export interface PartnerSupport {
  type: SupportType
  partners: CardPartner[]
}

export interface CurrencySupport {
  type: SupportType
  currencies?: string[]
}

export interface CountrySupport {
  type: SupportType
  countries: Country[]
}

export interface Eligibility {
  partners: PartnerSupport
  currencies: CurrencySupport
  countries: CountrySupport
}

export type CreateTemplateFormData = {
  name: string
  externalName: string
  eligibility: Eligibility
}

export type CreateTemplateDialogProps = {
  isOpen: boolean
  onClose: () => void
  onSave: (template: CreateTemplateFormData) => Promise<void>
  onError?: (error: Error) => void
}

export interface EditDialogProps {
  isOpen: boolean
  onClose: () => void
  onSave: () => void
  title: string
  isDisabled: boolean
  children: React.ReactNode
}
